export const STRAPI_API_URL = process.env.REACT_APP_STRAPI_API_URL || '/graphql';
export const STRAPI_CONFIG_API_URL = process.env.REACT_APP_STRAPI_CONFIG_API_URL || '/api';
export const SERVICE_API_URL = process.env.REACT_APP_SERVICE_API_URL || '/mmc/graphql';

// Нужен абсолютный путь для создания Meilisearch инстанса, но при этом нельзя хардкодить адрес стенда
export const SEARCH_URL =
  process.env.REACT_APP_SEARCH_URL || `${window.location.protocol}//${window.location.hostname}/meilisearch`;
